import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";


const supplierAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'supplierAPI',
    endpoints: (builder) => ({


        getSuppliersList: builder.mutation({
            query: (data) => ({
                url: `/Supplier/GetSuppliersList`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSupplierBySupplierKey: builder.query({
            query: (plSupplierKey) => ({
                url: `/Supplier/GetSupplierBySupplierKey?plSupplierKey=${plSupplierKey}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSupplierPOTypes: builder.query({
            query: () => ({
                url: `/Supplier/GetSupplierPOTypes`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSupplierRecentPOsList: builder.mutation({
            query: (data) => ({
                url: `/Supplier/GetSupplierRecentPOsList`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addSupplier: builder.mutation({
            query: (data) => ({
                url: `/Supplier/AddSupplier`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateSupplier: builder.mutation({
            query: (data) => ({
                url: `/Supplier/UpdateSupplier`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteSupplier: builder.mutation({
            query: (plSupplierKey) => ({
                url: `/Supplier/DeleteSupplier?plSupplierKey=${plSupplierKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllSupplierList: builder.query({
            query: () => ({
                url: `/Supplier/GetAllSupplierList`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getsupplierGetNextPartNumber: builder.query({
            query: (plSupplierKey) => ({
                url: `/Supplier/GetsupplierGetNextPartNumber?plSupplierKey=${plSupplierKey}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
});

export const {
    useGetSuppliersListMutation,
    useLazyGetSupplierBySupplierKeyQuery,
    useLazyGetSupplierPOTypesQuery,
    useGetSupplierRecentPOsListMutation,
    useAddSupplierMutation,
    useUpdateSupplierMutation,
    useDeleteSupplierMutation,
    useLazyGetAllSupplierListQuery,
    useLazyGetsupplierGetNextPartNumberQuery
} = supplierAPI;

export default supplierAPI;